/* Checkout nudge: with 1 or 2 qualifying pieces in the cart, Check out first offers the next offer step.
   Runs before Zecpe (window capture beats Zecpe's document capture). "No thanks" hands the tap back to Zecpe. */
(() => {
  if (customElements.get('soul-offer-nudge')) return;

  const SKIP_KEY = 'soulNudgeSkipped';
  const skipped = () => { try { return JSON.parse(sessionStorage.getItem(SKIP_KEY) || '[]'); } catch (err) { return []; } };
  const skip = (count) => { try { const s = skipped(); if (!s.includes(count)) s.push(count); sessionStorage.setItem(SKIP_KEY, JSON.stringify(s)); } catch (err) {} };
  const track = (name, count) => {
    try { if (typeof gtag === 'function') gtag('event', name, { event_category: 'cart_offer', pieces: count }); } catch (err) {}
    (window.dataLayer = window.dataLayer || []).push({ event: name, pieces: count });
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  class SoulOfferNudge extends HTMLElement {
    connectedCallback() {
      this.sheet = this.querySelector('[data-qv-sheet]');
      this.body = this.querySelector('[data-nudge-body]');
      this.querySelector('[data-qv-backdrop]').addEventListener('click', () => this.dismiss());
      this.querySelector('[data-qv-close]').addEventListener('click', () => this.dismiss());
      this.addEventListener('keyup', (e) => e.key === 'Escape' && this.dismiss());
      window.addEventListener('popstate', () => {
        if (!this.isOpen || (history.state && history.state.soulNudge)) return;
        // the phone's back button is a "not now" too; our own close() has already decided
        if (!this.closing && !this.changedCart) { skip(this.count); track('offer_nudge_skip', this.count); }
        this.hide();
      });
      window.addEventListener('pageshow', (e) => e.persisted && this.isOpen && this.hide());
      if (window.soulSheetSwipe) window.soulSheetSwipe.call(this);
      this.body.addEventListener('click', (e) => this.onBodyClick(e));

      window.addEventListener('click', (e) => {
        const btn = e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout');
        if (!btn || btn.disabled) return;
        if (this.bypass) { this.bypass = false; return; }
        const ladder = this.ladderFor(btn); if (!ladder) return;
        const count = parseInt(ladder.dataset.count || '0', 10);
        if ((count !== 1 && count !== 2) || skipped().includes(count)) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        this.open(btn, ladder);
      }, true);
    }

    ladderFor(btn) {
      const root = btn.closest('cart-drawer') || document.querySelector('cart-items') || document;
      return root.querySelector('soul-offer-ladder');
    }

    // cheapest qualifying pieces rendered by soul-offer-ladder, priced for this cart
    picks(ladder) {
      const d = ladder.dataset; const count = +d.count; const original = +d.original; const final = +d.final;
      const nodes = ladder.querySelector('template[data-nudge-picks]')?.content.querySelectorAll('[data-pick]') || [];
      return [...nodes].map((n) => {
        const price = +n.dataset.price;
        // count 1: the lower priced piece is free, so the cart pays the higher of the two
        // count 2: three pieces at 50% replace Buy 1 Get 1 on two
        const extra = count === 1 ? Math.max(0, price - original) : Math.round((original + price) / 2) - final;
        return { id: n.dataset.id, price, extra, title: n.dataset.title, url: n.dataset.url, img: n.dataset.img };
      }).sort((a, b) => a.extra - b.extra || b.price - a.price).slice(0, 6); // free ones first, the most valuable free piece leading
    }

    money(cents) {
      const v = Math.abs(cents) / 100;
      return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }

    render(ladder) {
      const count = +ladder.dataset.count;
      const head = count === 1
        ? '<h2 class="soul-nudge__title" id="SoulNudge-title">Wait! Your 2nd piece is FREE 🎁</h2><p class="soul-nudge__text">Add one more anti-tarnish piece and the lower-priced one is on us.</p>'
        : '<h2 class="soul-nudge__title" id="SoulNudge-title">1 more = FLAT 50% OFF on all 3</h2><p class="soul-nudge__text">Add one more piece and every anti-tarnish piece in your bag is half price.</p>';
      const cards = this.picks(ladder).map((p) => {
        const label = count === 1 ? (p.extra <= 0 ? 'FREE' : `+${this.money(p.extra)}`) : (p.extra < 0 ? `Total drops ${this.money(p.extra)}` : (p.extra === 0 ? 'No extra cost' : `+${this.money(p.extra)}`));
        const good = p.extra <= 0;
        return `<div class="soul-nudge__card">
          <a class="soul-nudge__img" href="${esc(p.url)}" tabindex="-1"><img src="${esc(p.img)}" alt="" loading="lazy" width="120" height="120"></a>
          <p class="soul-nudge__name">${esc(p.title)}</p>
          <p class="soul-nudge__cost${good ? ' is-good' : ''}">${label}</p>
          <button type="button" class="soul-nudge__add" data-nudge-add="${esc(p.id)}">+ Add</button>
        </div>`;
      }).join('');
      this.body.innerHTML = `<div class="soul-nudge">${head}
        ${cards ? `<div class="soul-nudge__row">${cards}</div>` : ''}
        <div class="soul-nudge__actions">
          <a class="soul-nudge__primary" href="${esc(this.collectionUrl)}" data-nudge-more>Add one more</a>
          <button type="button" class="soul-nudge__skip" data-nudge-skip><span data-label="No thanks, check out"></span></button>
        </div>
      </div>`;
    }

    open(btn, ladder) {
      this.btn = btn; this.count = +ladder.dataset.count; this.changedCart = false; this.afterClose = null;
      this.collectionUrl = this.dataset.collectionUrl || '/collections/all';
      this.render(ladder);
      this.isOpen = true; this.hidden = false; this.sheet.style.transform = '';
      document.body.classList.add('overflow-hidden');
      history.pushState({ soulNudge: true }, '');
      requestAnimationFrame(() => this.classList.add('is-open'));
      if (typeof trapFocus === 'function') trapFocus(this.sheet, this.querySelector('[data-qv-close]'));
      track('offer_nudge_shown', this.count);
    }

    // closing without adding counts as "not now" for this number of pieces
    dismiss() { if (!this.changedCart) { skip(this.count); track('offer_nudge_skip', this.count); } this.close(); }

    close(after) {
      if (!this.isOpen) return;
      this.afterClose = after || null; this.closing = true;
      if (history.state && history.state.soulNudge) history.back(); else this.hide();
    }

    hide() {
      this.isOpen = false; this.closing = false;
      this.classList.remove('is-open');
      const drawerOpen = document.querySelector('cart-drawer.active');
      if (!drawerOpen) document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.btn);
      setTimeout(() => { if (!this.isOpen) { this.hidden = true; this.body.innerHTML = ''; } }, 320);
      const after = this.afterClose; this.afterClose = null;
      if (after) setTimeout(after, 0);
    }

    // hand the tap back to the real Check out button; Zecpe takes it from there
    checkout() {
      const id = this.btn && this.btn.id;
      this.close(() => {
        const btn = (id && document.getElementById(id)) || this.btn; if (!btn) return;
        this.bypass = true; btn.click();
        setTimeout(() => { this.bypass = false; }, 0);
      });
    }

    async add(button) {
      button.disabled = true; button.textContent = 'Adding…';
      const drawer = document.querySelector('cart-drawer'); const inDrawer = !!(this.btn && this.btn.closest('cart-drawer'));
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(button.dataset.nudgeAdd), quantity: 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) });
        const state = await res.json();
        if (!res.ok) { button.textContent = 'Sold out'; return; }
        this.changedCart = true; track('offer_nudge_add', this.count);
        if (drawer && inDrawer) { drawer.classList.remove('is-empty'); drawer.renderContents(state); }
        else {
          const bubble = document.getElementById('cart-icon-bubble'); const b = state.sections && state.sections['cart-icon-bubble'];
          if (bubble && b) bubble.innerHTML = new DOMParser().parseFromString(b, 'text/html').querySelector('.shopify-section')?.innerHTML || bubble.innerHTML;
          // cart page: refresh the items (the new ladder there fires the celebration) and the totals
          document.querySelector('cart-items')?.onCartUpdate?.();
          const footer = document.getElementById('main-cart-footer');
          if (footer && footer.dataset.id) fetch(`${window.location.pathname}?section_id=${footer.dataset.id}`).then((r) => r.text()).then((html) => {
            const src = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-contents'); const dst = footer.querySelector('.js-contents');
            if (src && dst) dst.innerHTML = src.innerHTML;
          }).catch(() => {});
        }
        const fresh = state.sections && new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html').querySelector('soul-offer-ladder');
        // unlocked: close and let the cart celebrate (soul.js toast + confetti)
        if (fresh && +fresh.dataset.count > this.count) this.close();
        else { button.textContent = 'Added ✓'; }
      } catch (err) { button.disabled = false; button.textContent = '+ Add'; }
    }

    onBodyClick(e) {
      const add = e.target.closest('[data-nudge-add]'); if (add) { this.add(add); return; }
      if (e.target.closest('[data-nudge-skip]')) { skip(this.count); track('offer_nudge_skip', this.count); this.checkout(); return; }
      const link = e.target.closest('a[href]');
      if (link) { e.preventDefault(); const href = link.href; this.close(() => this.leave(href)); }
    }

    // leaving from on top of the cart drawer: take the drawer's back step off first
    leave(href) {
      const drawer = document.querySelector('cart-drawer.active');
      if (drawer && history.state && history.state.soulPanel) {
        window.addEventListener('popstate', () => { window.location.href = href; }, { once: true });
        drawer.close();
      } else window.location.href = href;
    }
  }

  customElements.define('soul-offer-nudge', SoulOfferNudge);
})();
